"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateContext = void 0;
const react_1 = require("react");
exports.TemplateContext = (0, react_1.createContext)({
    enableDocx4j: false,
});
//# sourceMappingURL=template-context.js.map